import type UUID from './uuid';
import { assertIsInstanceOfUUID } from '../assertions';

interface IWorkflow {
	readonly uuid: UUID;
}

export default class Workflow implements IWorkflow {
	public get uuid(): UUID {
		return this.#uuid;
	}

	#uuid: UUID;
	public constructor({ uuid }: IWorkflow) {
		assertIsInstanceOfUUID(uuid);
		this.#uuid = uuid;
	}
}
